// Toggle/Component.tsx
import { observer } from 'mobx-react-lite';
import { Box, Button, getVariant } from '@apia/theme';

export type SwitchMultipleOption<T extends string> = {
  value: T;
  label: string;
};

export const SwitchMultiple = observer(
  <T extends string>({
    options,
    defaultValue,
    value,
    onChange,
    variant,
  }: {
    options: SwitchMultipleOption<T>[];
    defaultValue?: T;
    value?: T;
    onChange: (ev: T) => unknown;
    variant?: string;
  }) => {
    const actualValue = value ?? defaultValue;
    return (
      <Box
        {...getVariant(variant ?? 'layout.validations.fields.switchMultiple')}
      >
        {options.map((o, idx) => {
          const active = actualValue === o.value;

          return (
            <Button
              className={`switchButton ${active ? 'active' : ''} ${idx === 0 ? 'first' : idx === options.length - 1 ? 'last' : 'middle'}`}
              type="button"
              key={o.value}
              onClick={() => {
                onChange(o.value);
              }}
            >
              {o.label}
            </Button>
          );
        })}
      </Box>
    );
  },
);
